import Landing from './Landing/Landing';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
